// extracted by mini-css-extract-plugin
export default {"productWrapper":"ProductsPreviewList_productWrapper__bvZW8"};